<template>
  <div>
    <div class="analytic-wrapper">
      <div>
        <CustomDatePicker
          clearable
          :label="$t('fromUp')"
          :name="$t('date')"
          v-model="form.fromDate"
          rules="required"
          class="user_input data_item data_item_calendar"
          icon="mdi-calendar-month small"
        ></CustomDatePicker>
      </div>
      <div>
        <CustomDatePicker
          clearable
          :label="$t('fromTo')"
          v-model="form.toDate"
          :name="$t('date')"
          rules="required"
          class="user_input data_item data_item_calendar"
          icon="mdi-calendar-month small"
        ></CustomDatePicker>
      </div>
      <div class="mb-2">
        <v-btn @click="getWarehouses" color="primary">{{ $t("search") }}</v-btn>
      </div>
    </div>
    <div v-if="!loading" v-for="item in items" :key="item.id">
      <div>
        <chart-donut-new
          :partial="`${item.busyCarriageCount}/${item.carriageCount}`"
          :percentage="+item.occupancyPercent"
          :allData="item"
        >
          <template #name> {{ item.name }}</template>
          <template #allPlace>{{ item.carriageCount }}</template>
          <template #empty
            >{{ item.carriageCount - item.busyCarriageCount }}
          </template>
          <template #full>{{ item.busyCarriageCount }}</template>
        </chart-donut-new>
      </div>
    </div>
  </div>
</template>

<script>
import "./chart-warehouse.scss";
import ChartDonutNew from "@/components/ui/chart/ChartDonutNew.vue";
// import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";

export default {
  name: "ChartWarehouse",
  data() {
    return {
      form: {
        fromDate: "",
        toDate: "",
      },
      items: [],
      params: {
        page: 0,
        limit: 10,
        fromDate: "",
        toDate: "",
      },
      loading: false,
      slideSettings: {
        mouseDrag: false,
        wheelControl: false,
        breakpoints: {
          800: {
            itemsToShow: 1,
          },
          1100: {
            itemsToShow: 2,
          },
          1200: {
            itemsToShow: 3,
          },
        },
      },
    };
  },
  components: { ChartDonutNew },
  computed: {
    hasPagination() {
      const { width } = this.$vuetify.breakpoint;
      let itemsToShow;
      if (width < 800) {
        itemsToShow = 0;
      } else if (width < 1100) {
        itemsToShow = 1;
      } else if (width < 1200) {
        itemsToShow = 2;
      } else itemsToShow = 3;
      return this.items.length > itemsToShow;
    },
  },
  methods: {
    carouselPrevSlide() {
      const { carouselRef } = this.$refs;
      carouselRef.slidePrev();
    },
    carouselNextSlide() {
      const { carouselRef } = this.$refs;
      const { width } = this.$vuetify.breakpoint;
      let itemsToShow = 4;
      if (width <= 800) {
        itemsToShow = 1;
      } else if (width <= 1100) {
        itemsToShow = 3;
      }
      if (carouselRef.currentSlide + itemsToShow <= this.items.length) {
        carouselRef.slideNext();
      }
    },
    async getWarehouses() {
      this.params = {
        ...this.params,
        ...this.form,
      };
      this.loading = true;
      try {
        const {
          data: { data },
        } = await this.$http.get("dashboards/warehouse-fullness", {
          params: this.params,
        });
        this.items = data.map((item) => {
          item.name_uz = item.nameUz;
          item.name_ru = item.nameRu;
          item.name_en = item.nameEn;
          item.name_cyrl = item.name;
          return item;
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getWarehouses();
  },
};
</script>
<style scoped lang="scss">
.analytic-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 20px;

  .user_input {
    margin-bottom: 0 !important;
  }
  button {
    margin-bottom: -2.5px;
  }
}

@media (max-width: 450px) {
  .analytic-wrapper {
    flex-wrap: wrap;
    gap: 10px !important;
    margin-bottom: 20px;
  }
}
</style>
